import cx from 'classnames'
import { FC } from 'react'
import { getTotalSecondsBeforeExpiration } from '../../../helpers/orders'
import { Styles } from '../../../helpers/types'
import { SpotCrossSelection } from '../../../store/lastLook/types'
import { Order, OrderStatus, OrderType } from '../../../store/order/types'
import { useAppSelector } from '../../../store/types'
import { showTsySetting } from '../../../store/webSettings/selectors'
import { SecurityModalInfo } from '../../../store/windows/types'
import { getServerTimeDelayMs } from '../../../store/ws/selectors'
import DurationTimer from '../../Timer/DurationTimer'
import LeftInfoPanel from '../LeftInfoPanel'
import PriceHedge from '../PriceHedge'

interface Props {
  order: Order
  type: OrderType
  securityModalInfo: SecurityModalInfo
  tradeAmt: string | undefined
  // FIXME: define style classname types
  styles: Styles
  price: number
  orderStatusComp: OrderStatus | undefined
  shouldAlertPriceChange?: boolean
  spotCrossSelection: string
  setSpotCrossSelection: (st: SpotCrossSelection) => void
  selectedAccount?: string
  setSelectedAccount?: (st: string) => void
  currency: string
  isTreasury: boolean
}

const LastLookModalContent: FC<Props> = (props) => {
  const {
    order,
    securityModalInfo,
    tradeAmt,
    styles,
    orderStatusComp,
    shouldAlertPriceChange,
    spotCrossSelection,
    setSpotCrossSelection,
    selectedAccount,
    setSelectedAccount,
    currency,
    isTreasury
  } = props

  const serverTimeDelayMs = useAppSelector(getServerTimeDelayMs)
  const showTsy = useAppSelector(showTsySetting)

  const isActive = orderStatusComp === 'waitingForConfirmation'

  const minSizeForTsyHedge = securityModalInfo.minSizeForTsyHedge || '500'

  const disableButton =
    !securityModalInfo?.benchmarkPrice ||
    ['accepted', 'rejected', 'cancelled'].includes(orderStatusComp ?? '')

  const disableCrossButton =
    disableButton ||
    Number(tradeAmt) < Number(minSizeForTsyHedge) ||
    !order.isSpreadOrder

  const { totalSeconds } = getTotalSecondsBeforeExpiration(
    order.aggressorOrder?.expiration,
    order.aggressorOrder?.submitTime,
    serverTimeDelayMs
  )

  return (
    <div
      className={cx(
        styles.content,
        order.type === 'buy' ? styles.isBuy : styles.isSell,
        setSelectedAccount ? styles.aggressorContent : styles.lastLookContent
      )}
    >
      <LeftInfoPanel
        currency={currency}
        isTreasury={isTreasury}
        priceValueStyles={shouldAlertPriceChange ? styles.warning : ''}
        securityModalInfo={securityModalInfo}
        selectedAccount={selectedAccount}
        tradeAmt={
          <p
            data-testid="lastlook-amt"
            className={cx(styles.value, styles.buySellColor)}
          >
            {tradeAmt}
          </p>
        }
        updateOnChanges={[securityModalInfo.price]}
      />
      <div className={styles.rightInfos}>
        <div className={styles.timerWrapper}>
          {order.aggressorOrder?.expiration && (
            <DurationTimer
              duration={totalSeconds}
              expireTime={order.aggressorOrder.expiration}
              preset="big"
              stopped={!isActive}
            />
          )}
        </div>
        {showTsy && (
          <PriceHedge
            disableBtns={disableButton}
            disableCrossBtn={disableCrossButton}
            setSpotCrossSelection={setSpotCrossSelection}
            spotCrossSelection={spotCrossSelection}
          />
        )}
      </div>
    </div>
  )
}

export default LastLookModalContent
